import { AlertTriangle, Info } from 'lucide-react'
import type { BannerData } from '@/hooks/useBanner'

interface ServiceBannerProps {
  banner: BannerData | null
}

export function ServiceBanner({ banner }: ServiceBannerProps) {
  if (!banner?.isActive) return null

  const isWarning = banner.bannerType === 'warning'

  return (
    <div
      role={isWarning ? 'alert' : 'status'}
      className={`flex items-start gap-2 px-4 py-3 text-sm border-b ${
        isWarning
          ? 'bg-amber-50 border-amber-200 text-amber-800'
          : 'bg-blue-50 border-blue-200 text-blue-800'
      }`}
    >
      {isWarning ? (
        <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />
      ) : (
        <Info className="w-4 h-4 shrink-0 mt-0.5" />
      )}
      <p className="leading-snug">{banner.message}</p>
    </div>
  )
}
